import React, { useState } from 'react'
import Creatable from 'react-select/creatable'

import { InputFeedback } from './InputFeedback'
import { selectStyles } from 'shared/reactSelectStyles'

function ControlledCreatableSelect({
  className,
  onChange,
  noOptionsMessage,
  limit,
  isClearable = true,
  isMulti = true,
  isOptionUnique = true,
  hideSelectedOptions = true,
  value = isMulti ? [] : {},
  error,
  disabled,
  innerRef,
  ...props
}) {
  const checkLimit = inputValue => {
    if (isMulti && limit && value?.length === limit) {
      return I18n.t('js.components.creatableselect.limit_reached', {
        count: limit,
      })
    }
    return I18n.t('js.components.creatableselect.add_item', {
      item: inputValue,
    })
  }

  const onCreateOption = newOption => {
    const option = newOption.trim()
    const formattedOption = option.toLowerCase()

    if (isMulti) {
      if (!limit || (limit && value.length < limit)) {
        onChange([...value, { label: option, value: formattedOption }])
      }
    } else {
      onChange({ label: option, value: formattedOption })
    }
  }

  const onSelectChange = values => {
    if (isMulti && (!limit || (limit && values.length < limit))) {
      onChange(values)
    }
  }

  return (
    <>
      <Creatable
        ref={innerRef}
        isClearable={isClearable}
        isMulti={isMulti}
        isOptionUnique={isOptionUnique}
        hideSelectedOptions={hideSelectedOptions}
        styles={selectStyles}
        className={`fullwidth ${className}`}
        noOptionsMessage={noOptionsMessage ? () => noOptionsMessage : undefined}
        value={value}
        onCreateOption={onCreateOption}
        onChange={onSelectChange}
        formatCreateLabel={checkLimit}
        error={error}
        isDisabled={disabled}
        {...props}
      />
      {error && <InputFeedback type="error" message={error} />}
    </>
  )
}

function UncontrolledCreatableSelect({
  isMulti = true,
  defaultValue = isMulti ? [] : {},
  ...props
}) {
  const [value, setValue] = useState(defaultValue)

  return (
    <ControlledCreatableSelect
      value={value}
      onChange={selectValue => setValue(selectValue)}
      {...props}
    />
  )
}

export const CreatableSelect = React.forwardRef((props, ref) => {
  if (props.onChange)
    return <ControlledCreatableSelect innerRef={ref} {...props} />
  return <UncontrolledCreatableSelect innerRef={ref} {...props} />
})
